<!-- `mat-sidenav-container` : sidenav en mode `side` + `opened`, donc toujours
     visible — même rendu que la grille CSS d'origine, mais avec le rôle
     `navigation` et la sémantique de liste apportés par `mat-nav-list`. -->
<mat-sidenav-container class="gs-shell" [hasBackdrop]="false">
  <mat-sidenav mode="side" opened disableClose>
    <div class="gs-sidebar-inner">
      <div class="mb-3 flex items-center gap-2.5 px-2">
        <div
          class="flex size-9 items-center justify-center rounded-sm bg-primary text-lg font-extrabold text-on-primary"
        >
          G
        </div>
        <div class="flex flex-col leading-tight">
          <span class="text-[15px] font-extrabold text-on-surface">Gisgo Ops</span>
          <span class="text-[11px] font-semibold text-on-surface-variant">Bizerte · interne</span>
        </div>
      </div>

      <mat-nav-list class="!p-0">
        @for (section of sections(); track section.title) {
          <div
            class="mt-3 mb-1 px-2 text-[11px] font-bold tracking-wide text-on-surface-variant uppercase"
          >
            {{ section.title }}
          </div>
          @for (entry of section.entries; track entry.path) {
            @if (canAccess(entry)) {
              <a
                mat-list-item
                [routerLink]="entry.path"
                routerLinkActive
                #link="routerLinkActive"
                [activated]="link.isActive"
                [class.gs-nav-active]="link.isActive"
              >
                <span class="icon" matListItemIcon>{{ entry.icon }}</span>
                <span matListItemTitle>{{ entry.label }}</span>
                @if (badgeFor(entry); as badge) {
                  <span matListItemMeta class="gs-nav-badge rounded-full bg-error px-1.5 py-0.5">
                    {{ badge }}
                  </span>
                }
              </a>
            } @else {
              <!-- RBAC visible : verrouillé + explication, jamais masqué (spec design §4).
                 `disabled` sur un `mat-list-item` le sort du parcours clavier ET
                 l'annonce comme indisponible — la `div` d'avant ne faisait ni l'un
                 ni l'autre. -->
              <a
                mat-list-item
                disabled
                [matTooltip]="'Réservé aux rôles ' + entry.roles.join(', ') + ' et admin'"
              >
                <span class="icon" matListItemIcon>{{ entry.icon }}</span>
                <span matListItemTitle>{{ entry.label }}</span>
                <span class="icon gs-nav-lock" matListItemMeta>lock</span>
              </a>
            }
          }
        }
      </mat-nav-list>

      <div class="grow"></div>

      <mat-nav-list class="!p-0">
        <a
          mat-list-item
          routerLink="/reglages"
          routerLinkActive
          #settingsLink="routerLinkActive"
          [activated]="settingsLink.isActive"
          [class.gs-nav-active]="settingsLink.isActive"
        >
          <span class="icon" matListItemIcon>settings</span>
          <span matListItemTitle>Réglages</span>
        </a>
      </mat-nav-list>

      <div
        class="mt-2 flex items-center gap-2.5 rounded-md border border-outline-variant px-3 py-2.5"
      >
        <div
          class="flex size-8 items-center justify-center rounded-full bg-secondary-container text-xs font-extrabold text-on-secondary-container"
        >
          {{ auth.initials() }}
        </div>
        <div class="flex min-w-0 flex-col leading-tight">
          <span class="truncate text-[13px] font-bold text-on-surface">{{
            auth.user()?.name
          }}</span>
          <span class="text-[11px] font-semibold text-on-surface-variant">
            {{ auth.role() ? roleLabels[auth.role()!] : '—' }}
          </span>
        </div>
        <span class="icon ml-auto text-on-surface-variant">unfold_more</span>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="gs-content">
    <!-- Topbar mockup : titre + live-pill · filtres de la page · stats à droite -->
    <mat-toolbar class="gs-topbar">
      <h1
        class="m-0 flex items-center gap-2.5 text-[17px] font-extrabold tracking-[-0.01em] whitespace-nowrap text-on-surface"
      >
        @if (slots.title(); as titleTpl) {
          <ng-container [ngTemplateOutlet]="titleTpl" />
        } @else {
          {{ pageTitle() }}
          <span class="live-pill"><span class="dot"></span>Temps réel</span>
        }
      </h1>

      @if (slots.filters(); as filtersTpl) {
        <div class="flex items-center gap-2">
          <ng-container [ngTemplateOutlet]="filtersTpl" />
        </div>
      }

      <div class="grow"></div>

      @if (slots.stats(); as statsTpl) {
        <div class="flex items-center gap-2">
          <ng-container [ngTemplateOutlet]="statsTpl" />
        </div>
      }

      <button
        matIconButton
        type="button"
        class="shrink-0"
        (click)="themeService.toggle()"
        [matTooltip]="themeService.theme() === 'light' ? 'Passer en sombre' : 'Passer en clair'"
      >
        <span class="icon">
          {{ themeService.theme() === 'light' ? 'dark_mode' : 'light_mode' }}
        </span>
      </button>
    </mat-toolbar>

    <!-- fullBleed (console/flotte) : la carte occupe tout, pas de padding -->
    <main
      class="min-h-0 bg-surface-dim"
      [class]="fullBleed() ? 'overflow-hidden' : 'overflow-y-auto p-5'"
    >
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
